REGION_COOKIE = 'doterra_login_region';
DEFAULT_REGION = 'us';
DEFAULT_PRIVACY_POLICY_LINK = 'https://www.doterra.com/US/en/usa-online-privacy-notice';
DEFAULT_TERMS_OF_USE_LINK = 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions';

REGIONS = {
    ae: {
        active: true,
        name: 'United Arab Emirates',
        defaultLanguage: 'en-ae',
        privacyPolicyLink: 'https://media.doterra.com/ae/ar/brochures/privacy-policy.pdf',
        termsOfUseLink: 'https://media.doterra.com/ae/ar/flyers/site-use-policy.pdf',
        languages: {
          'en-ae': { active: true, code: 'en-ae', name: 'English', url: 'https://www.doterra.com/AE/en_AE' },
          'ar-ae': { active: true, code: 'ar-ae', name: 'عربى', url: 'https://www.doterra.com/AE/ar_AE' },
        },
    },
    afgac: {
        active: true,
        name: 'Not Listed',
        defaultLanguage: 'en-gac',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'https://www.doterra.com',
    },
    asgac: {
        active: true,
        name: 'Not Listed',
        defaultLanguage: 'en-gac',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'https://www.doterra.com',
    },
    au: {
        active: true,
        name: 'Australia',
        defaultLanguage: 'en-au',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'en-au': {active: true, code: 'en-au', name: 'English', url: 'https://www.doterra.com/AU/en_AU'}
            /*'en-au': {active: true, code: 'en-au', name: 'English', url: '/AU/en', hasEcommEnv: true},//TODO: need to figure out how to do this dynamically for when AU/NZ goes live or some kind of toggle
    		'zh-au': {active: true, code: 'zh-au', name: '中文', url: '/AU/zh', hasEcommEnv: true}*/
        }
    },
    bg: {
        active: true,
        name: "Bulgaria",
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'http://doterraeveryday.eu/'
    },
    br: {
        active: true,
        name: 'Brazil',
        defaultLanguage: 'pt-br',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'pt-br': {active: true, code: 'pt-br', name: 'Português', url: 'https://www.doterra.com/BR/pt_BR'},
        }
    },
    ca: {
        active: true,
        name: 'Canada',
        defaultLanguage: 'en-ca',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'en-ca': {active: true, code: 'en-ca', name: 'English', url: '/CA/en', hasEcommEnv: true},
            'fr-ca': {active: true, code: 'fr-ca', name: 'Français', url: '/CA/fr', hasEcommEnv: true},
            'zh-ca': {active: true, code: 'zh-ca', name: '中文', url: '/CA/zh', hasEcommEnv: true},
        }
    },
    gcn: {
        active: true,
        name: 'Greater China',
        locations: [
                    {code: 'cn', order: 1, name: 'China'},
                    {code: 'hk', order: 2, name: 'Hong Kong'},
                    {code: 'tw', order: 3, name: 'Taiwan'},
                ]
    },
    cagac: {
        active: true,
        name: 'Not Listed',
        defaultLanguage: 'en-gac',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'https://www.doterra.com',
    },
    cam: {
        active: true,
        name: 'Central America',
        locations: [
                    {code: 'cr', order: 1, name: 'Costa Rica'},
                    {code: 'gt', order: 2, name: 'Guatemala'},
                    {code: 'sv', order: 3, name: 'El Salvador'},
                    {code: 'cagac', order: 4, name: 'Not Listed'},
                ]
    },
    cl: {
        active: true,
        name: 'Chile',
        defaultLanguage: 'es-cl',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'https://www.doterra.com/CL/es_CL'
    },
    cn: {
        active: true,
        name: 'China',
        defaultLanguage: 'zh-cn',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'zh-cn': {active: true, code: 'zh-cn', name: '中文', url: 'https://doterra.cn/client/index.html#/home'},
        }
    },
    co: {
        active: true,
        name: "Colombia",
        defaultLanguage: 'es-co',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'es-co': {active: true, code: 'es-co', name: 'Español', url: 'https://www.doterra.com/CO/es_CO'},
        }
    },
    cr: {
        active: true,
        name: 'Costa Rica',
        defaultLanguage: 'es-cr',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'es-cr': {active: true, code: 'es-cr', name: 'Español', url: 'https://www.doterra.com/CR/es_CR'},
        }
    },
    ec: {
        active: true,
        name: "Ecuador",
        defaultLanguage: 'es-ec',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'es-ec': {active: true, code: 'es-ec', name: 'Español', url: 'https://www.doterra.com/EC/es_EC'},
        }
    },
    eu: {
        active: true,
        name: "Europe",
        defaultLanguage: 'en-eu',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'bg-me': {active: true, code: 'bg-me', name: 'Български', url: 'https://www.doterra.com/ME/bg_ME'},
            'cs-me': {active: true, code: 'cs-me', name: 'Čeština', url: 'https://www.doterra.com/ME/cs_ME'},
            'da-me': {active: true, code: 'da-me', name: 'Dansk', url: 'https://www.doterra.com/ME/da_ME'},
            'de-me': {active: true, code: 'de-me', name: 'Deutsch', url: 'https://www.doterra.com/ME/de_ME'},
            'et-me': {active: true, code: 'et-me', name: 'Eesti', url: 'https://www.doterra.com/ME/et_ME'},
            'en-me': {active: true, code: 'en-me', name: 'English', url: 'https://www.doterra.com/ME/en_ME'},
            'es-me': {active: true, code: 'es-me', name: 'Español', url: 'https://www.doterra.com/ME/es_ME'},
            'fr-me': {active: true, code: 'fr-me', name: 'Français', url: 'https://www.doterra.com/ME/fr_ME'},
            'it-me': {active: true, code: 'it-me', name: 'Italiano', url: 'https://www.doterra.com/ME/it_ME'},
            'lv-me': {active: true, code: 'lv-me', name: 'Latviešu', url: 'https://www.doterra.com/ME/lv_ME'},
            'lt-me': {active: true, code: 'lt-me', name: 'Lietuvių', url: 'https://www.doterra.com/ME/lt_ME'},
            'hu-me': {active: true, code: 'hu-me', name: 'Magyar', url: 'https://www.doterra.com/ME/hu_ME'},
            'nl-me': {active: true, code: 'nl-me', name: 'Nederlands', url: 'https://www.doterra.com/ME/nl_ME'},
            'no-me': {active: true, code: 'no-me', name: 'Norsk', url: 'https://www.doterra.com/ME/no_ME'},
            'pl-me': {active: true, code: 'pl-me', name: 'Polski', url: 'https://www.doterra.com/ME/pl_ME'},
            'pt-me': {active: true, code: 'pt-me', name: 'Português', url: 'https://www.doterra.com/ME/pt_ME'},
            'ru-me': {active: true, code: 'ru-me', name: 'Русский', url: 'https://www.doterra.com/ME/ru_ME'},
            'ro-me': {active: true, code: 'ro-me', name: 'Română', url: 'https://www.doterra.com/ME/ro_ME'},
            'sl-me': {active: true, code: 'sl-me', name: 'Slovenščina', url: 'https://www.doterra.com/ME/sl_ME'},
            'sk-me': {active: true, code: 'sk-me', name: 'Slovenský', url: 'https://www.doterra.com/ME/sk_ME'},
            'fi-me': {active: true, code: 'fi-me', name: 'Suomi', url: 'https://www.doterra.com/ME/fi_ME'},
            'sv-me': {active: true, code: 'sv-me', name: 'Svenska', url: 'https://www.doterra.com/ME/sv_ME'},
        }
    },
    eugac: {
        active: true,
        name: 'Not Listed',
        defaultLanguage: 'en-gac',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'https://www.doterra.com/ME/en_ME',
    },
    fr: {
        active: true,
        name: "France",
        defaultLanguage: 'fr-fr',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'http://doterraeveryday.eu/'
    },
    gt: {
        active: true,
        name: 'Guatemala',
        defaultLanguage: 'es-gt',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'es-gt': {active: true, code: 'es-gt', name: 'Español', url: 'http://doterraeveryday-la.com/gt/'},
        }
    },
    hk: {
        active: true,
        name: 'Hong Kong',
        defaultLanguage: 'zh-hk',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'en-hk': {active: true, code: 'en-hk', name: 'English', url: 'https://www.doterra.com/HK/en_HK', hasEcommEnv: false},
            'zh-hk': {active: true, code: 'zh-hk', name: '中文', url: 'https://www.doterra.com/HK/zh_HK/', hasEcommEnv: false},
        }
    },
    in: {
        active: true,
        name: 'India',
        defaultLanguage: 'en-in',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'https://www.doterra.com/IN/en_IN'
    },
    il: {
        active: true,
        name: 'Israel',
        defaultLanguage: 'he-il',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'he-il': {active: true, code: 'he-il', name: 'עִברִית', url: 'https://www.doterra.com/IL/he_IL'},
            'en-il': {active: true, code: 'en-il', name: 'English', url: 'https://www.doterra.com/IL/en_IL'},
            'ru-il': {active: true, code: 'ru-il', name: 'русский', url: 'https://www.doterra.com/IL/ru_IL'},
        }
    },
    jp: {
        active: true,
        name: 'Japan',
        defaultLanguage: 'ja-jp',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'ja-jp': {active: true, code: 'ja-jp', name: '日本語', url: 'https://www.doterra.com/JP/ja_JP'},
        }
    },
    kr: {
        active: true,
        name: 'Republic of Korea',
        defaultLanguage: 'ko-kr',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'ko-kr': {active: true, code: 'ko-kr', name: '한국어', url: 'https://www.doterra.com/KR/ko_KR'},
        }
    },
    kz: {
        active: true,
        name: 'Kazakhstan',
        defaultLanguage: 'ru-kz',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'ru-kz': {active: true, code: 'ru-kz', name: 'Russian', url: 'https://www.doterra.com/KZ/ru_KZ'},
        }
    },
    my: {
        active: true,
        name: 'Malaysia',
        defaultLanguage: 'en-my',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'en-my': {active: true, code: 'en-my', name: 'English', url: 'https://www.doterra.com/MY/en_MY', hasEcommEnv: false},
            'ms-my': {active: true, code: 'ms-my', name: 'Bahasa', url: 'https://www.doterra.com/MY/ms_MY', hasEcommEnv: false},
            'zh-my': {active: true, code: 'zh-my', name: '中文', url: 'https://www.doterra.com/MY/zh_MY', hasEcommEnv: false},

        }
    },
    mx: {
        active: true,
        name: 'Mexico',
        defaultLanguage: 'es-mx',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'es-mx': {active: true, code: 'es-mx', name: 'Español', url: 'https://www.doterra.com/MX/es_MX'},
        }
    },
    nagac: {
        active: true,
        name: 'Not Listed',
        defaultLanguage: 'en-gac',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'https://www.doterra.com',
    },
    nz: {
        active: true,
        name: 'New Zealand',
        defaultLanguage: 'en-nz',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'en-nz': {active: true, code: 'en-nz', name: 'English', url: 'https://www.doterra.com/NZ/en_NZ'}
        	/*'en-nz': {active: true, code: 'en-nz', name: 'English', url: '/NZ/en', hasEcommEnv: true},//TODO: need to figure out how to do this dynamically for when AU/NZ goes live or some kind of toggle
    		'zh-nz': {active: true, code: 'zh-nz', name: '中文', url: '/NZ/zh', hasEcommEnv: true}*/
        }
    },
    ocgac: {
        active: true,
        name: 'Not Listed',
        defaultLanguage: 'en-gac',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'https://www.doterra.com',
    },
    ph: {
        active: true,
        name: 'Philippines',
        defaultLanguage: 'en-ph',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'en-ph': {active: true, code: 'en-ph', name: 'English', url: 'https://www.doterra.com/PH/en_PH'},
        }
    },
    ru: {
        active: true,
        name: 'Russia',
        defaultLanguage: 'ru-ru',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'ru-ru': {active: true, code: 'ru-ru', name: 'русский', url: 'https://www.doterra.com/RU/ru_RU'},
        }
    },
    sagac: {
        active: true,
        name: 'Not Listed',
        defaultLanguage: 'en-gac',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        url: 'https://www.doterra.com',
    },
    sg: {
        active: true,
        name: 'Singapore',
        defaultLanguage: 'zh-sg',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'en-sg': {active: true, code: 'en-sg', name: 'English', url: 'https://www.doterra.com/SG/en_SG'},
        }
    },
    sv: {
        active: true,
        name: 'El Salvador',
        privacyPolicyLink: 'https://media.doterra.com/sv/es/brochures/privacy-notice.pdf',
        termsOfUseLink: 'https://media.doterra.com/sv/es/brochures/terms-and-conditions.pdf',
        languages: {
            'es-sv': {active: true, code: 'es-sv', name: 'Español', url: 'https://www.doterra.com/SV/es_SV'},
        }
    },
    th: {
        active: true,
        name: "Thailand",
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'en-th': {active: true, code: 'en-th', name: 'English', url: 'https://www.doterra.com/TH/en_TH'},
            'th-th': {active: true, code: 'th-th', name: 'ไทย', url: 'https://www.doterra.com/TH/th_TH'},
        }
    },
    tw: {
        active: true,
        name: 'Taiwan',
        defaultLanguage: 'zh-tw',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'zh-tw': {active: true, code: 'zh-tw', name: '中文', url: 'https://www.doterra.com/TW/zh_TW'},
        }
    },
    ua: {
        active: true,
        name: 'Ukraine',
        defaultLanguage: 'uk-ua',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'uk-ua': {active: true, code: 'uk-ua', name: 'українська мова', url: 'https://www.doterra.com/UA/uk_UA'},
        }
    },
    us: {
        active: true,
        name: 'United States',
        defaultLanguage: 'en-us',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'en-us': {active: true, code: 'en-us', name: 'English', url: '/US/en', hasEcommEnv: true},
            'es-us': {active: true, code: 'es-us', name: 'Español', url: '/US/es', hasEcommEnv: true},
            'zh-us': {active: true, code: 'zh-us', name: '中文', url: '/US/zh', hasEcommEnv: true},
        }
    },
    za: {
        active: true,
        name: 'South Africa',
        defaultLanguage: 'en-za',
        privacyPolicyLink: 'https://www.doterra.com/US/en/usa-online-privacy-notice',
        termsOfUseLink: 'https://www.doterra.com/US/en/wellness-advocate-terms-and-conditions',
        languages: {
            'en-za': {active: true, code: 'en-za', name: 'English', url: 'https://www.doterra.com/ZA/en_ZA'},
        }
    },
};

function extractRegion(region) {
    if (region.includes("_")) {
        region = region.split(/_(.+)/)[1].toLowerCase();
    }

    return region;
}

function validateRegion(region) {
    if (_.has(REGIONS, region)) {
        if (!region.active) {
            region = DEFAULT_REGION;
        }
    } else {
        region = DEFAULT_REGION;
    }

    return region;
}
